export default __webpack_public_path__ + "static/media/oath-of-peak-logo.744489c3.svg";